// Why a media view failed: one value of media_viewed.reason (DESIGN §9). Only the enum leaves the
// worker or the page, never a message, URL, key, binding or byte offset.
import { Kcm1Error } from "./kcm1.js";

export const MEDIA_FAILURE_REASONS = Object.freeze([
  "key_denied",
  "key_unavailable",
  "session_lost",
  "fetch_failed",
  "range_unsupported",
  "integrity",
  "unsupported_format",
  "sw_timeout",
  "other",
]);

/** An error that knows its reason. Subclasses keep their own name and message. */
export class MediaFailure extends Error {
  constructor(reason, message = "media-failure") {
    super(message);
    this.name = "MediaFailure";
    this.reason = MEDIA_FAILURE_REASONS.includes(reason) ? reason : "other";
  }
}

/** The reason for anything thrown while serving media. It never reads the message. */
export function failureReason(error) {
  if (error instanceof MediaFailure) return error.reason;
  if (error instanceof Kcm1Error) return error.code === "envelope" ? "unsupported_format" : "integrity";
  return "other";
}

/** The reason for a media element error (MediaError.code) when the worker recorded none. */
export function mediaErrorReason(code) {
  if (code === 2) return "fetch_failed";
  if (code === 3 || code === 4) return "unsupported_format";
  return "other";
}
